<template>
  <div class="RpaTitle">
    <h1 class="zhTitle">{{ zh }}</h1>
    <p class="enTitle">{{ en }}</p>
  </div>
</template>

<script>
/**
 * rpa页面面板（标题、英文标题）
 */
export default {
  name: 'RpaTitle',
  props: {
    zh: {
      type: String,
      default: ''
    },
    en: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.all {
  width: 1200px;
  margin: 60px auto 0;
}
.RpaTitle {
  .zhTitle {
    font-size: 32px;
    color: #333;
    letter-spacing: 2px;
    line-height: 45px;
    text-align: center;
    font-weight: 500;
  }
  .enTitle {
    font-size: 22px;
    color: #999;
    letter-spacing: 2px;
    line-height: 45px;
    text-align: center;
    font-weight: 500;
    margin-top: -6px;
  }
}
</style>
